import { createContext, useContext, useEffect, useState } from "react"
import AppConfig from "../models/AppConfig";
import { fetchClientAppCustomData } from '../api/repositoryEP';

export const availableAppLanguages: Array<string> = ['es', 'us', 'mx', 'fr', 'gb', 'en'];

const defaultconfigValues: AppConfig = {
    chainName:"",
    hasRewardsContracted: false,
    hasVerificationCode: false,
    mainColor: "#3DBAB3",
    secondaryColor: "#414745",
    scripts: [],
    dateFormat: "DD/MM/YYYY",
    availableLanguages: [],
    siteName: '',
    legalTexts: {
        legalWarning: '',
        privacity: '',
        cookies: '',
        termsAndConditions: ''
    },
    images: {
        brandLogo: "",
        appLogo: "",
        loginBackGround: ""
    },
    availableCurrencies: [],
    contactPhones: [],
    customRegisterFields: [],
    clientData: {
        id: '',
        name: '',
        identityCode: '',
        powerBiUrl: ''
    }
};

const AppConfigContext = createContext<{
    config: AppConfig,
    setConfig: React.Dispatch<React.SetStateAction<AppConfig>>, // <-- esto es nuevo
    device: 'mobile' | 'tablet' | 'desktop'
}>({
    config: defaultconfigValues,
    setConfig: () => { }, // valor por defecto
    device: 'desktop'
});

export const AppConfigProvider: React.FC<{ children: React.ReactNode, responsive: 'mobile' | 'tablet' | 'desktop' }> = ({ children, responsive }) => {
    const [config, setConfig] = useState<AppConfig>(defaultconfigValues);
    const [device, setDevice] = useState<'mobile' | 'tablet' | 'desktop'>('desktop');

    useEffect(() => {
        if (window.location.href.indexOf("/error/") == -1) {
            fetchClientAppCustomData().then(response => {
                if (response) {
                    setConfig((response.data as AppConfig));
                }
            }).finally(() => {
            });
        }

    }, []);

    useEffect(() => {
        setDevice(responsive);
    }, [responsive])

    useEffect(() => {
        if (config.chainName) {
            document.title = `BO ${config.chainName}`;
        }
    }, [config])




    return (
        <AppConfigContext.Provider value={{ config, setConfig, device }}>
            {children}
        </AppConfigContext.Provider>

    )
}

export const useAppConfig = (): { config: AppConfig, setConfig: React.Dispatch<React.SetStateAction<AppConfig>>, device: 'mobile' | 'tablet' | 'desktop' } => {
    return useContext(AppConfigContext);
}